import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePlant } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for updating a Plant.
 */
export const useUpdatePlant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call updatePlant.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Plant['id']} params.id - The ID of the Plant to update.
     * @param {Pella.ProductionRequestAPI.UpdatePlantInput} params.input - The inputs for updating the Plant.
     */
    mutationFn: ({ id, input }) => updatePlant(id, input),
    onSuccess: () => {
      toast.dismiss();
      toast.success('Plant updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PLANT_DATA] });
    },
  });
};
